// extracted by mini-css-extract-plugin
module.exports = {"gradientHeight":"102px","gradient-wrapper":"gradient-wrapper__gradient-wrapper___1VSzJ"};